import { NavLink } from 'react-router';

export const Footer = () => {
  return (
    <div className="w-full">
      <div className="w-full h-[250px] border-t mt-12 flex flex-row gap-40 justify-center pt-5">
        <div className="flex flex-col gap-2 text-slate-700 cursor-pointer">
          <span className="font-semibold">Socials</span>
          <span className="hover:text-slate-900">GitHub</span>
          <span className="hover:text-slate-900">X</span>
        </div>
        <div className="flex flex-col gap-2 text-slate-700 cursor-pointer">
          <span className="font-semibold">Support</span>
          <NavLink to="/api-docs">
            <span className="hover:text-slate-900">API Docs</span>
          </NavLink>
          <span className="hover:text-slate-900">Changelog</span>
          <span className="hover:text-slate-900">FAQ</span>
          <a href="mailto:support@promptslate.com">
            <span className="hover:text-slate-900">Contact</span>
          </a>
          <span className="hover:text-slate-900">System Status</span>
        </div>
        <div className="flex flex-col gap-2 text-slate-800 cursor-pointer">
          <span className="font-semibold">Legal</span>
          <NavLink to="/terms">
            <span className="hover:text-slate-900">Terms</span>
          </NavLink>
          <NavLink to="/privacy">
            <span className="hover:text-slate-900">Privacy</span>
          </NavLink>
        </div>
      </div>
      <div className="w-full h-[60px] border-t mt-12 flex items-center justify-center">
        &copy; {new Date().getFullYear()} PromptSlate. All rights reserved.
      </div>
    </div>
  );
};
